module Microsoft.ApplicationInsights.Context {

    "use strict";

    export interface ISample {
        /**
        * Sample rate
        */
        sampleRate: number;
    }
}